export const bewaardeItemsAnalyticsEvents = [
  'notitieAangemaakt',
  'notitieVerwijderd',
  'notitieGewijzigd',
  'bookmarkAangemaakt',
  'bookmarkVerwijderd',
] as const;
